import React from "react";

const ExpandCollaps = ({ collaps, setCollaps }) => {
  return (
    <>
      {/* <button
        type="button"
        onClick={() => setCollaps(!collaps)}
        id="sidebarCollapse"
        className={collaps ? "collaps" : ""}
      >
        <img src="/images/community/left-ar.png" />
      </button> */}
      {/* <button
                className="btn btn-dark d-inline-block d-lg-none ml-auto"
                type="button"
                data-toggle="collapse"
                data-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
            >
                <i className="fas fa-align-justify"></i>
            </button> */}
    </>
  );
};

export default ExpandCollaps;
